import { useRecoilValue, useSetRecoilState } from "recoil"
import quizPhaseState from "../../recoil/quizPhase/atom"
import { toast } from "react-toastify"
import { useCookies } from "react-cookie"
import {
  focusedItemIdxState,
  quizResponseListState,
} from "../../recoil/QuizPage/atoms"
import { useQuizIng } from "./useQuizIng"
import { useQuizWrapup } from "./useQuizWrapup"
import { useEffect, useState } from "react"

const useGoToNextRound = (refs: React.RefObject<HTMLDivElement>[]) => {
  const setQuizPhase = useSetRecoilState(quizPhaseState)
  const quizResponseList = useRecoilValue(quizResponseListState)
  const setFocusedItemIdx = useSetRecoilState(focusedItemIdxState)
  const [cookie] = useCookies(["quizRound"])

  const { isLoading: isQuizIngLoading, mutate: getQuizIng } = useQuizIng()
  const { isLoading: isQuizWrapupLoading, mutate: getQuizWrapup } =
    useQuizWrapup()

  const [isNextRoundLoading, setIsNextRoundLoading] = useState(false)

  useEffect(() => {
    setIsNextRoundLoading(isQuizIngLoading || isQuizWrapupLoading)
  }, [isQuizIngLoading, isQuizWrapupLoading])

  const goToNextRound = () => {
    const notAnsweredAll = quizResponseList.some((response, idx) => {
      if (!response) {
        toast.error("모든 문항에 답변해주세요", {
          position: "top-right",
          autoClose: 1000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        })
        setFocusedItemIdx(idx)
        refs[idx].current?.scrollIntoView({
          behavior: "smooth",
          block: "center",
        })
        return true
      }
      return false
    })

    if (!notAnsweredAll) {
      const quizRound = cookie.quizRound
      if (quizRound === 5) {
        setQuizPhase("submit")
      } else if (quizRound === 4) {
        getQuizWrapup()
      } else {
        getQuizIng()
      }
      setFocusedItemIdx(0)
    }
  }

  return { isNextRoundLoading, goToNextRound }
}

export default useGoToNextRound
